/**
 * @generated SignedSource<<84a9c9ef071099a29d05975ab627ee84>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedShippingAddress_user$data = {
  readonly serviceId: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"useUserGeoInfo_user">;
  readonly " $fragmentType": "PdpSharedShippingAddress_user";
};
export type PdpSharedShippingAddress_user$key = {
  readonly " $data"?: PdpSharedShippingAddress_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedShippingAddress_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedShippingAddress_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useUserGeoInfo_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "b0bbada1af0d2a6d095781e7053b93a5";

export default node;
